__turbopack_context__.v({
  "header": "Header-module__D5nTzG__header",
  "headerTitle": "Header-module__D5nTzG__headerTitle",
});
